import { render } from "./CreateMedia.vue?vue&type=template&id=e01e9f68"
import script from "./CreateMedia.vue?vue&type=script&lang=js"
export * from "./CreateMedia.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__